import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-dropdown-arrow',
  template: `
    <svg
      [class.rotate-180]="isOpen"
      class="w-4 h-4 transform transition-transform duration-200"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      viewBox="0 0 24 24"
    >
      <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
    </svg>
  `,
  standalone: true,
})
export class DropdownArrowComponent {
  @Input() isOpen = false;
}
